import React, { Component } from 'react';
import axios from 'axios';
import {Redirect, Link} from 'react-router-dom';
import './Payment.scss'
import PaymentSuccess from './../../../../src/images/payment-success.svg';
import PaymentFailed from './../../../../src/images/payment-failed.svg';

class PaymentCarbon extends Component {
   constructor(props) {
      super(props);
      this.state = {
         loggedIn: false,
         loading:true,
         payment: []
      };
   }
   
   componentDidMount() {
      const userData = localStorage.getItem("userData");
      if(userData){
         this.setState({loggedIn : true}) 
      }
      axios.get(process.env.REACT_APP_API_HOST + '/order/carbon/detail/'+this.props.match.params.orderId, {
         headers: {
            'Content-Type' : 'application/json',
            'token': JSON.parse(localStorage.getItem("userData")).token
         }
      })
      .then(res => {
         console.log('payment detail res ', res.data)
         this.setState({ payment: res.data.data, loading:false });
      })
   }
   
   render() {
      if(!localStorage.getItem('userData')){
         return (<Redirect to={'/'}/>)
      } 
      return (
         <div className="mpl-page cp-85">
            <div className="container">
               <div className="row">
                  <div className="col align-self-center">
                  <div className="card box-shadow" style={{width: '100%', maxWidth:'500px', margin: 'auto'}}>
                        <div className="card-body text-center">
                           {this.state.payment.paymentType === 0 ? (
                              <div className="">
                                 <h2 className="text-green text-bold lh-32">
                                    Terima kasih telah membantu melindungi Bumi! <br/>
                                 </h2>
                                 <img src={PaymentSuccess} alt="Payment Success" style={{width:'100%', maxWidth:'240px'}}/>
                                 <br/>
                                 <p className="lh-22">
                                    <b className="text-green text-bold">{this.state.payment.invoiceId}</b>
                                 </p>
                                 <p className="lh-22 text-gray text-small mb-4">
                                    Hi <b className="text-green text-bold">{this.state.payment.companyName}</b>, Terima kasih atas pembelian yang anda lakukan. Silahkan hubungi kami di email <b>payment@jejak.in</b> untuk mengkonfirmasi pembayaran anda. 
                                    
                                    <br/><br/>
                                    
                                    Kami akan melakukan perubahan status pada pembelian anda dalam waktu 1x24 jam setelah konfirmasi pembayaran kami terima. 

                                    <br/> <br/>
                                    Pastikan memberitahu kami <b>invoice number</b> pada pesan email.
                                 </p>
                                 <Link to={`/transaction/carbon`} className="btn btn-green btn-block text-center">
                                    LIHAT DAFTAR TRANSAKSI
                                 </Link>
                              </div>
                           ) : (
                              <React.Fragment>
                                 { this.state.payment.paymentType === 2 ? (
                                    <React.Fragment>
                                       { this.state.payment.paid === 0 ? (
                                          <div>
                                             <h2 className="text-red text-bold lh-26">
                                             Pembayaran tertunda!<br/>
                                             </h2>
                                             <img src={PaymentFailed} alt="Payment Success" style={{width:'100%', maxWidth:'240px'}}/>
                                             <p className="lh-22">
                                                <b className="text-red text-bold">{this.state.payment.invoiceId}</b>
                                             </p>
                                             <p className="lh-22 text-gray text-small mb-4">
                                                Tertunda! Pembayaran kamu belum selesai. Silahkan buka daftar transaksi untuk melanjutkan pembayaran!
                                             </p>
                                             <Link to={`/transaction/carbon`} className="btn btn-green btn-block text-center">
                                                LIHAT DAFTAR TRANSAKSI
                                             </Link>
                                          </div>
                                       ) : (
                                          <div>
                                             <h2 className="text-green text-bold lh-32">
                                                Terima kasih telah membantu melindungi Bumi! <br/>
                                             </h2>
                                             <img src={PaymentSuccess} alt="Payment Success" style={{width:'100%', maxWidth:'240px'}}/>
                                             <p className="lh-22">
                                                <b className="text-green text-bold">{this.state.payment.invoiceId}</b>
                                             </p>
                                             <p className="lh-22 text-gray text-small mb-4">
                                                Sukses! Pembayaran kamu telah kami terima.
                                             </p>
                                             <Link to={`/transaction/carbon`} className="btn btn-green btn-block text-center">
                                                LIHAT DAFTAR TRANSAKSI
                                             </Link>
                                          </div>
                                       ) }
                                    </React.Fragment>
                                 ) : ('') }
                              </React.Fragment>
                           )}
                           
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         )
      }
   }

   export default PaymentCarbon;